import { h, Component } from 'preact'
import L from 'leaflet'
import { Tooltip } from 'react-leaflet'
import { featureToLatLng } from '@shared/lib/geoJsonCompat'
import SelectableMarker from '@shared/components/MapSelectableMarker'
import colorScale from '@root/lib/colorScale'
import { latestValue, yearMeanValue } from '@root/lib/valuesFromStation'
import _ from './styles.sass'

export default class Markers extends Component {
  handleMarkerSelect = (index) => (e) => {
    this.context.actions.selectMarker({ byIndex: index })
    L.DomEvent.stopPropagation(e)
  }

  render (props) {
    const { isTouchEnabled, markers, selectedDataset } = this.props

    return <div>
      { markers.map((marker, i) => {
        const markerValue = selectedDataset === 'day'
          ? latestValue(marker)
          : yearMeanValue(marker)
        const markerColor = colorScale(markerValue).hex()

        const markerProps = {
          key: marker.properties.id,
          onClick: this.handleMarkerSelect(i),
          position: featureToLatLng(marker),
          hasStroke: true,
          strokeColor: 'white',
          fillColor: markerColor,
          optimizeForTouch: isTouchEnabled
        }

        const tooltipProps = {
          className: _.tooltip,
          opacity: 1,
          offset: [0, -60]
        }

        return <SelectableMarker {...markerProps}>
          { !isTouchEnabled && <Tooltip {...tooltipProps}>
            <div class={_.tooltipInner} style={{ backgroundColor: markerColor }}>
              <p class={_.stationName}>{ marker.properties.name }</p>
              <p class={_.stationValue}>{markerValue}<span> μg/m³</span></p>
              <div class={_.triangle} style={{ borderColor: markerColor }} />
            </div>
          </Tooltip> }
        </SelectableMarker>
      })}
    </div>
  }
}
